<ion-button
  id="user-avatar"
  color="primary"
  fill="solid"
  aria-haspopup="menu"
  [attr.aria-label]="'user.avatar' | translate"
  [attr.aria-expanded]="isOpen"
>
  {{ initials() }}
</ion-button>

<ion-popover
  trigger="user-avatar"
  triggerAction="click"
>
  <ng-template>
    <ion-content>
      <div
        class="user-dropdown"
        role="menu"
        [attr.aria-label]="'user.menu' | translate"
      >
        <p>{{ user().email }}</p>
        <ion-button
          fill="clear"
          role="menuitem"
          (click)="logout()"
          [disabled]="loading"
        >
          {{ 'page.settings.profile.logout' | translate }}
        </ion-button>
      </div>
    </ion-content>
  </ng-template>
</ion-popover>
